import React from 'react';
import LocationTemplate from './LocationTemplate';

const ColumbiaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Columbia"
      stateName="North Carolina"
      countyName="Tyrrell"
      zipCodes={["27925"]}
      latitude={35.9199}
      longitude={-76.2524}
      population={891}
      historicalFact="County seat of Tyrrell County; established in 1799 and named after Christopher Columbus."
      nearbyTowns={[
        "Plymouth, NC",
        "Creswell, NC",
        "Roper, NC",
        "Williamston, NC",
        "Washington, NC",
        "Manteo, NC",
        "Elizabeth City, NC",
        "Edenton, NC"
      ]}
    />
  );
};

export default ColumbiaPage;